import { PageContainer } from '@components/Layout/PageContainer';
import { WorkflowSection } from '@modules/workflow/components/WorkflowSection';
import { Grid, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router-dom';
import { TokenPurposeDialog } from '@modules/projectAccessTokens/components/TokenPurposeDialog';
import { MeetingsSection } from '../components/Sections/MeetingsSection';
import { MembersSection } from '../components/Sections/MembersSection';
import { ProgressWidget } from '../components/Sections/ProgressWidget';
import { RecentActivitySection } from '../components/Sections/RecentActivitySection';
import { TasksSection } from '../components/Sections/TasksSection';

export const ProjectHomePage: React.FC = () => {
  const { formatMessage } = useIntl();
  const [searchParams, setSearchParams] = useSearchParams();
  const [token, setToken] = useState<string | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    const tokenParam = searchParams.get('token');
    if (tokenParam) {
      setToken(tokenParam);
      setIsDialogOpen(true);
      // Remove token from URL to keep it clean
      searchParams.delete('token');
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const handleDialogClose = () => {
    setIsDialogOpen(false);
    setToken(null);
  };

  return (
    <>
      <PageContainer title={formatMessage({ id: 'Home' })}>
        <Stack gap={2}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 8 }}>
              <Stack gap={2}>
                <MeetingsSection />

                <TasksSection />

                <WorkflowSection />

                <RecentActivitySection />
              </Stack>
            </Grid> 

            <Grid size={{ xs: 12, md: 4 }}>
              <MembersSection />
    
              <ProgressWidget />
            </Grid>
          </Grid>
        </Stack>
      </PageContainer>
      {token && (
        <TokenPurposeDialog
          token={token}
          open={isDialogOpen}
          onClose={handleDialogClose}
        />
      )}
    </>
  );
};
